"use client";

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Cookie, X } from 'lucide-react';

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // We need to run this on the client after mount, since localStorage is not available on the server.
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // If no consent is stored, show the banner after a short delay to not be intrusive.
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    // When the user accepts, store the consent in localStorage and hide the banner.
    localStorage.setItem('cookie_consent', 'true');
    setIsVisible(false);
  };
  
  if (!isVisible) return null;

  return (
    <div id="cookie-banner" className="fixed bottom-4 left-4 right-4 md:left-auto md:max-w-sm bg-background border border-border p-4 rounded-2xl shadow-2xl z-50 transition-transform duration-500 animate-in slide-in-from-bottom-10">
      <div className="flex flex-col gap-3">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <Cookie className="h-6 w-6 text-primary animate-spin-slow" />
            <h4 className="font-bold text-foreground text-base">Cookies &amp; Privacy</h4>
          </div>
          <button aria-label="Close cookie banner" className="text-muted-foreground hover:text-foreground transition-colors -mt-1 -mr-1" onClick={acceptCookies}>
            <X className="h-6 w-6" />
          </button>
        </div>
        <p className="text-sm text-muted-foreground leading-relaxed">
          We use cookies to ensure you get the best experience on our website. By continuing, you agree to our <Link href="/privacy-policy" className="underline hover:text-primary">privacy policy</Link>.
        </p>
        <div className="flex gap-2 mt-1">
          <button className="flex-1 px-4 py-2 bg-muted text-muted-foreground text-sm font-semibold rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors" onClick={acceptCookies}>
            Settings
          </button>
          <button className="flex-1 px-4 py-2 bg-primary text-primary-foreground text-sm font-semibold rounded-lg hover:bg-primary/90 transition-colors shadow-lg shadow-primary/20" onClick={acceptCookies}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
